<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="total"
            :label="'Pôle'">
      <div v-if="!isSectorManager" class="column is-paddingless is-border-left" slot="right-content">
        <router-link :to="{name: 'PoleCreate'}" class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-plus-square"></i></span>
          <span>Nouveau Pôle</span>
        </router-link>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a @click="loadItems()" class="page-header-btn is-small is-square">
          <span class="icon"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="columns is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions"
      id="columns-collapse"
      :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-12 is-paddingless">
        <div class="is-border">
          <div class="">
            <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom is-last-fixed-small">
              <thead>
                <tr class="is-size-6">
                  <th>
                    <sortable @sort="sort('name', $event)" :sort="sortBy.name" label="Nom"></sortable>
                  </th>
                  <th class="has-text-centered is-narrow">Membres</th>
                  <th class="has-text-centered is-narrow">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in items" :key="p.pk" class="is-size-6" :id="'e' + p.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === p.pk}">
                  <router-link tag="td" :to="{name: 'PoleVue', params: {id: p.pk}, query: {returnId: p.pk, page: currentPage}}" class="is-cell-hoverable">
                    <a class="fullLink"><span class="">{{p.name}}</span></a>
                  </router-link>
                  <td class="is-narrow"><span v-if="p.users">{{p.users.length}}</span><span v-else>0</span> membre(s)</td>
                  <td class="has-text-centered actions">
                    <router-link class="button is-circle is-small tooltip is-tooltip-left" :to="{name: 'PoleVue', params: {id: p.pk}, query: {returnId: p.pk, page: currentPage}}" data-tooltip="Éditer">
                      <i class="fal fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun pôle disponible</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter } from '../../mixins'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'PoleList',
    props: {},
    data () {
      return {
        query: {},
        service: this.$api.poleService,
        loadDocuments: this.loadItems,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState(['scrollToEl', 'scrollToPage']),
      ...mapGetters(['isSectorManager'])
    },
    mixins: [GenericList, Sort, Filter],
    created () {
      this.loadItems()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/pole/PoleList.vue